

  import { Component, Vue } from 'vue-property-decorator'
  import axios from 'axios';
  import { GF } from '../helpers/gf';

  import WrsAlert from './wrsControls/WrsAlert.vue';
  import WrsSecurityDialog from './wrsControls/WrsSecurityDialog.vue';
  import WrsWizardStepHeader from './wrsControls/WrsWizardStepHeader.vue';
  import WrsWizardStepButtons from './wrsControls/WrsWizardStepButtons.vue';
  import WrsSearchButtons from './wrsControls/WrsSearchButtons.vue';

  // STP
  import WrsViSelect from './wrsControls/viControls/WrsViSelect.vue';
  import WrsSpacingItem from './wrsControls/viControls/Stp/WrsSpacingItem.vue';
  import WrsLabel from './wrsControls/WrsLabel.vue';

  import { IS_PRODUCTION_ENVIRONMENT, IS_VUEJS_ENVIRONMENT } from '../../olsStateManagement/helpers/constants';
  import { userService } from '../../olsStateManagement/services/devAuth.service';
  import AuthService from '../../olsStateManagement/services/auth.service';
  import {DEFAULT_ROOT_URL} from '../../olsStateManagement/helpers/constants'

  const authService = new AuthService();

  @Component({
    components: {
      'wrs-alert': WrsAlert,
      'wrs-security-dialog': WrsSecurityDialog,
      'wrs-wizard-step-header': WrsWizardStepHeader,
      'wrs-wizard-step-buttons': WrsWizardStepButtons,
      'wrs-search-buttons': WrsSearchButtons,
      'wrs-stp-spacing-item': WrsSpacingItem,
      'wrs-label': WrsLabel,
      'wrs-vi-select': WrsViSelect,
    },
  })

  export default class App extends Vue {
    public appVM: any = {};
    public VM: any = {};
    public previewLoaded = false;

    public dr = {
      clientId: 0,
      olsUserId: 0,
      statusId: 0,
      permitId: 0,
      permitIds: [] as any
    };

    public STEPIDS: any = {
      stepList: 1,
    };

    public dialog: any = {
      open: false,
      title: "",
      question: "",
    }

    public currentOlsUser: any = {};
    public clientData: any = {};

    public isAuthorized: boolean = false;
    public emailVerified: boolean = false;
    public userName: string = ""

    public reportGroups: any = {};
    public months: any = [];

    public loader: any = {
      loaded: false,
      loadedNoError: false,
      loading: false
    };

    isEmptyObject(obj: any) {
      if (obj == null) return true;
      return Object.keys(obj).length === 0;
    }

  // Mobile funcions
    public isMobile: boolean = false;
    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    }

    public expandedRows: any = [];
    public mobileRowExpanded: boolean = false;
    expandRow(index: any){ 
      const indexOfRow = this.expandedRows.indexOf(index)
      if(indexOfRow > -1){
        this.mobileRowExpanded = false;
        this.expandedRows.splice(indexOfRow,1);
        return;
      }
      this.mobileRowExpanded = true;
      this.expandedRows.push(index);
    }
    //created() {
    //  if (!IS_PRODUCTION_ENVIRONMENT && IS_VUEJS_ENVIRONMENT) {
    //    import('../../olsStateManagement/css/olsOverrideDev.scss')
    //  }
    //}

    mounted() {
      if (!IS_PRODUCTION_ENVIRONMENT && IS_VUEJS_ENVIRONMENT) {
        let userData = userService.getUser();
        userData
          .then((result) => {
            this.clientData = JSON.parse(JSON.stringify(result));
            this.loadData();
            this.isAuthorized = this.clientData.isLoggedIn;
          });
      } else {

        authService.getUser()
          .then((user:any) => {
            if(user) {
              this.emailVerified = authService.emailVerified();

              if(user.profile.email_verified) {
                this.isAuthorized = authService.isAuthorized();

                if(this.isAuthorized) {

                  this.userName = user.profile.name != null ? user.profile.name : user.profile.email;

                  let pOlsUser = sessionStorage.getItem('olsUser')
                  if(pOlsUser){
                    let olsUser = JSON.parse(pOlsUser);

                    axios
                      .get("olsUserProfile/getUserDefaultClient/" + olsUser.olsUserId + '/0/true',)
                        .then(response => {
                          this.clientData = response.data;
                          this.loadData()
                      })
                      .catch(error => console.log(error))
                  }
                }
                else {
                  authService.logout();
                }
              }
              // else in store.js user is redirected to email-not-verified page!
            }
          })
          .catch(error => console.log(error))
          .finally(() => {
            this.loader.loading = false;
            this.loader.loaded = true;
          })

      }
    }

    public loadData() {
      this.loader.loading = true;
      axios
        .get('permits/initpendingapplication/' + this.clientData.olsUserId + '/' + this.clientData.clientId)
        .then(response => {
          this.appVM = response.data;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
          this.loader.loaded = true;
          this.loader.loadedNoError = !this.appVM.securityError.hasError;
          this.selectedApps = [];
        });
    }

    public pendingStatusChanged() {
      this.getApplications();
    }

    public getApplications() {
      this.loader.loading = true;
      let statusId = this.appVM.pendingStatus.value;
      axios
        .get('permits/getpendingapplications/' + this.clientData.olsUserId + '/' + this.clientData.clientId + '/' + statusId)
        .then(response => {
          this.appVM.applications = response.data.applications;
          this.appVM.runtimeError = response.data.runtimeError;

          this.appVM.countOfCartItemsCanBeAdded = response.data.countOfCartItemsCanBeAdded;
          this.appVM.maximumOfCartItemsReachedError = response.data.maximumOfCartItemsReachedError;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
          this.loader.loaded = true;
          this.selectedApps = [];
        });
    }
    public closeDialog() {
      this.dialog.open = false;
    }
    //Documents
    //data
    public selectedApps: any = [];

    //getters
    get hideDefaultFooter() {
      if (this.appVM.applications) {
        return this.appVM.applications.length < 10;
      }
      return false;
    }
    get canCancelPermit() {
      if (this.selectedApps.length == 0) return false;
      var cnt = this.selectedApps.filter((item: any) => item.canCancel == false);
      //if there is ate least one that cannot cancel - we cannot cancel any
      return cnt == 0;
    }

    cancelPermit() {
      if (!this.canCancelPermit) return;

      this.dr.clientId = this.clientData.clientId;
      this.dr.olsUserId = this.clientData.olsUserId;
      this.dr.statusId = this.appVM.pendingStatus.value;
      this.dr.permitId = 0;
      this.dr.permitIds = [];
      for (var i = 0; i < this.selectedApps.length; i++) {
        this.dr.permitIds.push(this.selectedApps[i].id);
      }

      this.loader.loading = true;
      axios
        .post('permits/voidpendingapplication', this.dr)
        .then(response => {
          this.appVM.applications = response.data.applications;
          this.appVM.runtimeError = response.data.runtimeError;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.selectedApps = [];
          this.loader.loading = false;
          this.loader.loaded = true;
        });
    }
    get canAddToCartPermit() {
      var count = this.selectedApps.length;
      if (count == 0) return false;
      var anySelected = count > 0;

      var isReachedMax = false;

      if (count > this.appVM.countOfCartItemsCanBeAdded) {
        isReachedMax = true;
        GF.setAlertWarning(this.appVM.runtimeError, this.appVM.maximumOfCartItemsReachedError);
      }
      else {
        GF.clearAlert(this.appVM.runtimeError);
      }


      var allCanBeAddedToCart = true;
      for (var i = 0; i < this.selectedApps.length; i++) {
        if (!this.selectedApps[i].canAddToCart) {
          allCanBeAddedToCart = false;
        }
      }

      return anySelected && allCanBeAddedToCart && !isReachedMax;
    }

    addToCartPermit() {
      if (!this.canAddToCartPermit) return;

      this.dr.clientId = this.clientData.clientId;
      this.dr.olsUserId = this.clientData.olsUserId;
      this.dr.statusId = this.appVM.pendingStatus.value;
      this.dr.permitId = 0;
      this.dr.permitIds = [];
      for (var i = 0; i < this.selectedApps.length; i++) {
        this.dr.permitIds.push(this.selectedApps[i].id);
      }

      this.loader.loading = true;
      axios
        .post('permits/addtocartpendingapplication', this.dr)
        .then(response => {
          this.appVM.applications = response.data.applications;
          this.appVM.runtimeError = response.data.runtimeError;
          this.appVM.jumpToCart = response.data.jumpToCart;
        })
        .catch(error => console.log(error))
        .finally(() => {
          
          if (this.appVM.jumpToCart) {
           this.redirectToFullURL(this.appVM.shoppingCartWebAddress);
          }

          this.selectedApps = [];
          this.loader.loading = false;
          this.loader.loaded = true;
        });
    }

    selectPermit(id: number) {
      var index, len;

      this.selectedApps = [];

      for (index = 0, len = this.appVM.applications.length; index < len; ++index) {
        if (this.appVM.applications[index].isSelected) {
          this.selectedApps.push(this.appVM.applications[index]);
        }
      }
    }
    //selectPermit(id: number) {
    //  var index, len;
    //  this.selectedApplication = {};

    //  for (index = 0, len = this.appVM.applications.length; index < len; ++index) {
    //    if (this.appVM.applications[index].id == id) {
    //      this.appVM.applications[index].isSelected = true;
    //      this.selectedApplication = this.appVM.applications[index];
    //    }
    //    else
    //      this.appVM.applications[index].isSelected = false;
    //  }
    //}

    getTableHeaders() {
      return [
        { text: '', value: 'isSelected', sortable: false, width: '50px' },
        { text: this.appVM.wizardLabels.ApplicationNo, value: 'applicationId', align: 'start', sortable: false, width: '120px' },
        { text: this.appVM.wizardLabels.ApplicationStatus, value: 'status', align: 'start', sortable: false, width: '350px' },
        { text: this.appVM.wizardLabels.PlateNo, value: 'plateNumber', align: 'start', sortable: false, width: '100px' },
        { text: this.appVM.wizardLabels.VehicleInfo, value: 'vehicleInfo', align: 'start', sortable: false, width: '250px' },
        { text: this.appVM.wizardLabels.ApplicationDate, value: 'applicationDate', align: 'start', sortable: false, width: '150px' },
        { text: this.appVM.wizardLabels.PermitFees, value: 'fees', align: 'start', sortable: false, width: '120px' },
      ];
    }

    redirectToUrl(url: string) {
      return window.location.href = DEFAULT_ROOT_URL + url;
    }

    redirectToFullURL(url:string) {
      return window.location.href = url;
    }

    previewPermit(permitId: any) {
      this.previewLoaded = false;
      if (this.dialog.open) {
        this.dialog.open = false;
        return;
      }

      this.loader.loading = true;
      axios
        .get('permits/previewpermitapplication/' + this.clientData.olsUserId + '/' + this.clientData.clientId + '/' + permitId)
        .then(response => {
          this.VM = response.data;
          this.previewLoaded = true;
          this.dialog.open = true;
        })
        .catch(error => console.log(error))
        .finally(() => {
          this.loader.loading = false;
          this.loader.loaded = true;
        });
    }

    getConfigAxlesTableHeaders() {
      let caRecord = this.VM.configAxles.find((element: any) => element.restricted != null && element.restricted > 0);
      if (caRecord == null) {
        return [
          { text: this.VM.wizardLabels.Position, value: 'label', align: 'start', width: '150px' },
          { text: this.VM.wizardLabels.AxleType, value: 'axleName', width: '350px' },
          { text: this.VM.wizardLabels.Legal, value: 'legal', width: '100px' },
          { text: this.VM.wizardLabels.Actual, value: 'value', width: '100px' },
        ];
      }
      else {
        return [
          { text: this.VM.wizardLabels.Position, value: 'label', align: 'start', width: '150px' },
          { text: this.VM.wizardLabels.AxleType, value: 'axleName', width: '350px' },
          { text: this.VM.wizardLabels.Legal, value: 'legal', width: '100px' },
          { text: this.VM.wizardLabels.Restricted, value: 'restricted', width: '100px' },
          { text: this.VM.wizardLabels.Actual, value: 'value', width: '100px' },
        ];
      }
    }

    getDimensionTableHeaders() {
      return [
        { text: '', value: 'rowLabel', align: 'start', width: '80px' },
        { text: this.VM.wizardLabels.Min, value: 'minValue', width: '100px' },
        { text: this.VM.wizardLabels.Max, value: 'maxValue', width: '100px' },
        { text: this.VM.wizardLabels.Road, value: 'roadValue', width: '100px' },
        { text: this.VM.wizardLabels.Actual, value: 'value', width: '100px' },
      ];
    }
  }
